import { useState } from 'react';

export default function ZoomImage({ src, style, alt = '' }) {
  const [zoomed, setZoomed] = useState(false);
  return (
    <>
      <img src={src} alt={alt} onClick={(e) => { e.stopPropagation(); setZoomed(true); }}
        style={{ cursor: 'zoom-in', ...style }} />
      {zoomed && (
        <div onClick={(e) => { e.stopPropagation(); setZoomed(false); }}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000, cursor: 'zoom-out' }}>
          <img src={src} alt={alt} style={{ maxWidth: '92%', maxHeight: '92%', objectFit: 'contain', borderRadius: 8 }} />
        </div>
      )}
    </>
  );
}
